import React from 'react'
import { arrayOf, func, number, shape, string } from 'prop-types'
import { useUser } from '@fs/zion-user'
import { css } from '@emotion/core'
import { useContainerWidth } from '@fs/zion-ui'
import NameHeatmap from './NameHeatmap'
import ComparisonPanel from '../ComparisonPanel/ComparisonPanel'
import { useDSCState } from '../../../../../state/DSCStore'
import { useAamState } from '../../../state/AamStore'
import { getGender } from '../../../../../shared/helpers/person_Helper'
import { useComparisonByName } from '../../../hooks/hooks'

export default function NameHeatmapComparison({
  region,
  id,
  parsedNames,
  comparisonParsedNames,
  nameArgs,
  comparisonTargetNameArgs,
  comparisonTargetPerson,
  tileData,
  tileContentDispatch,
  tileComparisonContent,
  tileContentData,
  tileComparisonContentDispatch,
}) {
  const user = useUser()
  const atWidth = useContainerWidth()
  const dscState = useDSCState()
  const aamState = useAamState()
  const showComparison = useComparisonByName(
    aamState,
    comparisonTargetPerson,
    dscState,
    tileData,
    parsedNames,
    comparisonParsedNames
  )

  const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: ${atWidth({ default: 'column-reverse', md: 'row' })};
  `
  const background =
    comparisonTargetPerson?.gender && comparisonTargetPerson?.personId !== user.personId ? 'SOLID' : 'NONE' // Don't show a background if there isn't a comparisonTarget, or the comparisonTarget is the user

  return (
    <div css={containerStyle}>
      <ComparisonPanel gender={tileData?.gender?.toLowerCase()} background={background}>
        <NameHeatmap
          region={region}
          id={id}
          parsedNames={parsedNames}
          nameArgs={nameArgs}
          nameCounts={tileContentData?.[0]}
          tileContentDispatch={tileContentDispatch}
          gender={tileData?.gender?.toLowerCase()}
        />
      </ComparisonPanel>
      {showComparison && (
        <ComparisonPanel
          gender={
            comparisonTargetPerson?.gender
              ? comparisonTargetPerson?.gender.toLowerCase()
              : getGender(comparisonTargetPerson?.genderType)
          }
          background="SOLID"
        >
          <NameHeatmap
            region={region}
            id={id}
            parsedNames={comparisonParsedNames ?? parsedNames}
            nameArgs={comparisonTargetNameArgs}
            nameCounts={tileComparisonContent?.[0]}
            tileContentDispatch={tileComparisonContentDispatch}
            gender={
              comparisonTargetPerson?.gender
                ? comparisonTargetPerson?.gender.toLowerCase()
                : getGender(comparisonTargetPerson?.genderType)
            }
          />
        </ComparisonPanel>
      )}
    </div>
  )
}

NameHeatmapComparison.propTypes = {
  region: string,
  id: number,
  parsedNames: shape({
    firstName: shape({}),
    lastName: shape({}),
    middleNames: arrayOf(
      shape({
        name: string,
      })
    ),
  }),
  tileContentData: arrayOf(
    shape({
      category: string,
      categoryId: number,
      icon: string,
      id: number,
      languageOnly: string,
      localeOnly: string,
      price: number,
      subcategory: string,
      textHeadline: string,
      textTitle: string,
      tileType: string,
      year: number,
    })
  ),
  tileContentDispatch: func,
  tileData: shape({
    personId: string,
    gender: string,
  }),
}
